import { render, staticRenderFns } from "./ModalDeleteCustomer.vue?vue&type=template&id=bab3bec8&scoped=true&"
import script from "./ModalDeleteCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab3bec8",
  null
  
)

export default component.exports